import { render, staticRenderFns } from "./TitleDetailChartInfoV1.vue?vue&type=template&id=119796e8&scoped=true"
import script from "./TitleDetailChartInfoV1.vue?vue&type=script&lang=ts&setup=true"
export * from "./TitleDetailChartInfoV1.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TitleDetailChartInfoV1.vue?vue&type=style&index=0&id=119796e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119796e8",
  null
  
)

export default component.exports